<template>
    <div class="d-flex flex-column justify-content-center px-1">
    <HeaderBar/>
    
    <div
      class="d-flex flex-column mb-2 mt-4"
      style="font-size: 15px; font-weight: 500"
    >
        <v-offline 
        online-class="online"
        offline-class="offline"
        @detected-condition="onConnectionChange">
            <template v-if="online">
            <div class="flex w-full h-full justify-center items-center text-6xl">
                
            </div>
            </template>
            <template v-if="!online">
            <div class="flex w-full h-full justify-center items-center text-6xl">
            Sin Conexión
            </div>
            </template>
        </v-offline>
        <div class="add-economic-record-title1 mt-2 text-center "> Pesaje</div>
        <div class="d-flex justify-content-center headTitle">{{fincaName}}</div>
    </div>
        <div class="">
            <validation-observer ref="GanForm">
                <b-form class="auth-register-form " @submit.prevent="">
                        <validation-provider
                        #default="{ errors }" 
                        name="Fecha" 
                        rules="required">
                        <b-form-datepicker v-model="date" class="form-control" 
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        :min="minCfgDate" :max="maxCfgDate"/>
                        <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    
                    <b-form-group label="Animales" label-for="animal">
                        <!-- table -->
                        <small> ⬇ Seleccionar todos</small>
                        <vue-good-table :columns="columns" :rows="rows" styleClass="vgt-table bordered"
                            :search-options="{
                                enabled: false, 
                            }" 

                            :sort-options="{
                                enabled: true,
                            }"
                            
                            :pagination-options="{
                                enabled: true,
                                perPage: pageLength,
                                mode:'records',
                                nextLabel: ' Siguiente > ',
                                prevLabel: ' < Anterior ',
                                perPageDropdown: [10, 25,50,100],
                                dropdownAllowAll: false,
                                rowsPerPageLabel: 'Animales por página',
                                ofLabel: 'de',
                                position: 'bottom',
                                pageLabel: 'página',
                            }"

                            :select-options="{
                                enabled: true,
                                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                selectionInfoClass: 'custom-class',
                                selectionText: 'rows selected',
                                clearSelectionText: 'clear',
                                disableSelectInfo: true, // disable the select info panel on top
                                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                            }"

                            @on-selected-rows-change="selectedAnimal"
                        >
                        <template slot="table-row" slot-scope="props">

                            <!-- Column: Name -->
                            <span v-if="props.column.field === 'sex'" class="text-center">
                            <span v-if="props.row.sex===false" class="text-center">M</span>
                            <span v-if="props.row.sex===true" class="text-center">H</span>
                            
                            </span>

                            <!-- Column: Status -->
                            <span v-else-if="props.column.field === 'status'">
                            <b-badge :variant="statusVariant(props.row.status)">
                                {{ props.row.status }}
                            </b-badge>
                            </span>

                            <!-- Column: Common -->
                            <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>

                        <!-- pagination -->
                        <!-- <template slot="pagination-bottom" slot-scope="props">
                            <div class="d-flex justify-content-between flex-wrap">
                            <div class="d-flex align-items-center mb-0 mt-1">
                                <span class="text-nowrap ">
                                Mostrando 1 de
                                </span>
                                <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
                                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                                <span class="text-nowrap"> of {{ props.total }} registros </span>
                            </div>
                            </div>
                        </template> -->
                        </vue-good-table>
                    </b-form-group>                   
                    <div>
                        <div class="d-table">
                            <div id="weghins" v-for="(animal,animal_id) in weighins" :key="animal_id" >
                                <div class="d-flex">
                                    <b-form-group label="Animal" label-for="animal">
                                        <b-form-input id="animal" v-model="animal.animal_code" readonly />
                                    </b-form-group>
                                    <b-form-group label="Peso" label-for="peso">
                                        <validation-provider
                                        #default="{ errors }"
                                        name="Peso"
                                        rules="required"
                                        >
                                        <b-form-input id="peso" name="peso" v-model="animal.weight"  type="number" min="0" max="2000" onkeyup="if(value>2000) value=2000;"/>
                                        
                                        <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-2 mb-5">
                        <b-button type="submit" v-on:click="insertWeighins"
                            class="bg-primary dataButton d-flex align-items-center justify-content-center w-75 ">
                            <div class="ml-3"> Agregar Pesaje </div>
                            <div class="ml-3" style="color:#D7B92C">
                                <feather-icon icon="PlusIcon" size="20" />
                            </div>
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </div>
        <ControlMenu />
    </div>
</template>



<script>
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BFormTextarea, BFormGroup,BFormDatepicker, BFormInput, BForm, BImg, BButton, BFormCheckbox, BFormSelect } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'
import { VueGoodTable } from 'vue-good-table'
import axios from 'axios'
import { VOffline } from 'v-offline';
export default {
    components: {
        ControlMenu,
        HeaderBar,
        flatPickr,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormDatepicker,
        BFormGroup,
        BFormInput,
        BForm,
        required,
        vSelect,
        BFormSelect,
        BImg,
        BButton,
        BFormCheckbox,
        BFormTextarea,
        VueGoodTable,
        VOffline
    },
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 119)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate())
        return {
            farmId:localStorage.getItem('currentFarm'),
            fincaName:localStorage.getItem('currentFarmName'),
            online:false,
            date:now,
            pageLength: 10,
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            animal:{
                sex:0
            },
            animals:[],
            columns: [
                {
                    label: 'CODIGO',
                    field: 'number',
                },  
                {
                    label: 'ANIMAL',
                    field: 'name',
                },
                {
                    label: 'SEXO',
                    field: 'sex',
                },
                {
                    label: 'PESO',
                    field: 'weight',
                },
                {
                    label: 'EDAD',
                    field: 'age',
                },
            ],
            rows: [],
            weighins:[],
            weightt:{
                animal_id:0,
                weight:0,
                date:''
            },
        }
    },
    methods:{
        async fetchAnimals(config){
            let farmId= localStorage.getItem('currentFarm');
            if(this.online){
                //fetch(apiURL+"list/animals?farm_id="+farmId+"&sex=0", config)
                fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&state=1&recperpage=all", config)
                .then(response => response.json())
                .then(result => {
                    console.log(result.animals);
                    this.rows = result.animals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age}});
                    console.log(this.animals);
                })
            }
            else{
                let localanimals= JSON.parse(localStorage.getItem('animalsTemp'));
                if(localanimals.length>0){
                    this.rows=localanimals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age}});
                }
            }
            
        },

        selectedAnimal(params){
            console.log(params.selectedRows);
            this.weighins= params.selectedRows.map(item=>{return {farm_id:this.farmId,animal_code:item.number, animal_id:item.id, weight:item.weight,date:this.date}})
        },

        insertWeighins(){
            this.$refs.GanForm.validate().then(success => {
                if(success){
                    let self=this;
                    console.log(this.weighins);
                    
                    this.weighins.forEach(function (row){
                        row.date=self.date
                    });

                    if(this.online){
                        const token = localStorage.getItem("accessToken");
                        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                        var request= this.weighins.map(items =>this.$http.post("add/weighins", items, config));
                        axios.all(request)
                        .then(()=>{
                            this.$swal({
                                title: 'Registro de pesaje',
                                text: 'Se insertaron los pesajes de manera satisfactoria',
                                type: 'success',
                                icon:'success',
                                showCancelButton: false,
                                confirmButtonColor:'#5E8F23',
                                showCloseButton: true,
                                showLoaderOnConfirm: false  
                            }).then(function(){
                                history.back();
                            });
                        });
                    }else{
                        localStorage.setItem('weighinsInsert',JSON.stringify(this.weighins))
                        this.$swal({
                            title: 'Registro de pesaje',
                            text: 'Se insertaron los pesajes de manera local, recuerde sincronizar los datos cuando tenga conexión a internet.',
                            type: 'success',
                            icon:'success',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            history.back();
                        });
                    }
                    
                }
            })
        },
        onConnectionChange(val){
            this.online=val;
            console.log(val);
        },

    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.online=navigator.onLine;
        this.fetchAnimals(config);
    }
}
</script>
    

<style lang="scss">
.livestockTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    color: #5E5873;
}
.headTitle {
  font-weight: 600;
  font-size: 24px;
  color: #5E8F23;
}
.footer__navigation__page-btn {
  background-color: #5e8f23; /* color de fondo */
  color: white; /* color del texto */
  border-radius: 4px;
  padding: 5px 10px;
  text-align:center;
}
.footer__row-count{
  margin-top:10px;
}
.footer__navigation, .vgt-pull-right{
  text-align:center!important;
  width:100%;
  display:grid;
  margin-top:10px;
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>